import type { FC } from "react";
import React, { createContext, useContext, useState } from "react";

export type SimplifiedViewState = {
  isSimplifiedViewActive: boolean;
  disableSimplifiedView: () => void;
  activateSimplifiedView: () => void;
};

const SimplifiedViewContext = createContext<SimplifiedViewState>({
  isSimplifiedViewActive: false,
  disableSimplifiedView: () => {},
  activateSimplifiedView: () => {},
});

export const SimplifiedViewProvider: FC<{ children?: React.ReactNode }> = ({ children }) => {
  const [isSimplifiedViewActive, setIsSimplifiedViewActive] = useState(false);

  return (
    <SimplifiedViewContext.Provider
      value={{
        isSimplifiedViewActive,
        activateSimplifiedView: () => setIsSimplifiedViewActive(true),
        disableSimplifiedView: () => setIsSimplifiedViewActive(false),
      }}
    >
      {children}
    </SimplifiedViewContext.Provider>
  );
};

export const useSimplifiedViewContext = () => useContext(SimplifiedViewContext);
